import React from 'react';
import PropTypes from 'prop-types';
import SelectPrice from "../../common/primitives/SelectPrice";
import Label from "../../common/primitives/Label";
import Price, {ConvertToEUR} from "../../common/primitives/Price";

import styles from './CartLines.scss';

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import LoadingRow from "../../common/primitives/LoadingRow";
import {__t} from '../../common/lang/text-resource';

const CartLineVPS = ({data, taxonomy, removeService, changeServiceTerm, childServices, showAsPage}) => {
	let {
		id,
		serviceName,
		serviceTypeName,
		cPanelName,
		serviceId,
		priceData,
		servicePriceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		isNewService,
		isRenewService,
		canDelete,
		serviceType,
		loading,
		term,
		priceOrig,
		priceTopOrig,
		currency,
		isICN,
		accountName
	} = data;

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div
				data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}
	if (serviceType === 'PlanMail' && isRenewService === true) {
		serviceName = `${serviceTypeName}: ${serviceName}`
	}

	if (serviceType === 'DEDICATED_SERVER' && isRenewService === true) {
		serviceName = `${serviceTypeName}: ${cPanelName}`
	}
	const showSecondRow = (serviceType === 'CloudVPS' && isICN && isRenewService);
	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }
			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={`${serviceName}`}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs ${showAsPage ? '6@md' : ''}`}>
				  {
					  showAsPage === true ?
						<SelectPrice
						  name={id}
						  newPriceCol="price"
						  valueCol="priceId"
						  labelCol="term"
						  options={priceData}
						  oldPriceCol="oldPrice"
						  currencyCol="currency"
						  selected={servicePriceId}
						  onChange={changeServiceTerm}
						  onMenuOpen={() => {
							  HelperGoogleAnalytics.TrackServicePriceSelectorOpen(taxonomy, isNewService);
							  HelperGoogleAnalytics4.TrackServicePriceSelectorOpen(taxonomy, isNewService);
						  }}/>
						:
						<table className={styles.selectedPriceContainer}>
							<tbody>
							<tr>
								<td>{term}</td>
								<td className={styles.oldPrice}>
									{
										priceTopOrig !== priceOrig ? priceTopOrig : null
									}
									{SHVO.showEuroPrices && <>
										<br/>
										{
											priceTopOrig !== priceOrig ? ConvertToEUR(priceTopOrig) : null
										}
									</>}
								</td>
								<td>
									<Price
									  currency={currency}
									  value={priceOrig}
									  currencyClass={styles.currency}/>
									{SHVO.showEuroPrices && <>
										<br/>
										<Price
										  currency={'EUR'}
										  value={ConvertToEUR(priceOrig)}
										  currencyClass={styles.currency}/>
									</>}
								</td>
								<td data-layout='padding-right--md'>&nbsp;</td>
							</tr>
							</tbody>
						</table>
				  }
			  </div>
		  </div>

		  {
			  showSecondRow ?
				<div data-layout="row gutter-none start">
					<div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
						{
							<div data-layout="row gutter-none middle margin-top--xxs">
								<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								<div
								  className={styles.whNWTab}
								  data-layout="col 11 margin-top--xs padding-left--xs text-left">
									{__t('Име на сървър: :accountName', {accountName: accountName})}
								</div>
							</div>
						}
					</div>
				</div> : ''
		  }

		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Редове с отстъпки начало*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {
			  (discountPriceList > 0 && discountPromo < 100) ?
				<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
					<div
					  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left"
					  className={helpers.orderServiceDiscount}>
						{__t('–-discountPriceList%-допълнителна-партньорска-отсeb8c4f', {discountPriceList: discountPriceList})}
					</div>
				</div>
				: ''
		  }

		  {
			  (discountPromo > 0) ?
				<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
					<div
					  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left"
					  className={helpers.orderServiceDiscount}>
						{__t('–:discountPromo% отстъпка от промокод', {discountPromo: discountPromo})}
					</div>
				</div>
				: ''
		  }

		  {
			  (discountTerm > 0 && discountPromo < 100) ?
				<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
					<div
					  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left"
					  className={helpers.orderServiceDiscount}>
						{isRenewService ? __t('–:discountTerm% промоционална отстъпка', {discountTerm: discountTerm}) : __t('–:discountTerm% отстъпка за нова услуга', {discountTerm: discountTerm})}
					</div>
				</div>
				: ''
		  }
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Редове с отстъпки край*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}


		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги начало*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {
			  (childServices) ?
				childServices.map((child, i) => {
					return (
					  <div key={i} data-layout="row gutter-none middle margin-top--xxs">
						  <div className={styles.removeContainer} data-layout='col 1 margin-top--sm'>
							  {
								child.canDelete === true &&
								<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
										className={`${buttons.buttonImage} ${styles.removeButton}`}
										onClick={() => removeService(child.id, child.serviceId, child.serviceName)}>
									<img src={removeImg} alt={__t("Remove")}/>
								</button>
							  }
						  </div>
						  <div
							className={styles.childServiceContainer}
							data-layout={`col 11 margin-top--smm padding-left--xs text-left ${showAsPage ? '5@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td>
										  {
											  (child.serviceType !== 'CpanelLicensing' && (child.serviceType === 'BACKUP_SPACE' && child.quantity > 1)) ?
												`${child.quantity} ` : null
										  }

										  {(child.serviceType === 'RAM_VPS') ? 'MB ' :
											(child.serviceType === 'BACKUP_SPACE' && child.quantity > 1) ? 'GB ' :
											  (child.serviceType === 'IPADDRESS' && child.isRenewService !== true) ? (child.quantity === 1) ? __t('брой') : __t('броя') : ''}
										  {child.serviceType === 'SpamExpert' ?
											<span title={child.serviceTypeName}>{child.serviceTypeName}</span> :
											<span title={child.serviceName}>{child.serviceName}</span>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>

						  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
						  <div
							className={styles.childServiceContainerPrice}
							data-layout={`col 11 margin-top--xs padding-left--xs text-left ${showAsPage ? '6@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td>
										  {term}
									  </td>
									  <td className={styles.oldPrice}>
										  {
											  child.priceOrig !== child.priceTopOrig ? child.priceTopOrig : null
										  }
										  {SHVO.showEuroPrices && <>
											  <br/>
											  {
												  child.priceOrig !== child.priceTopOrig ? ConvertToEUR(child.priceTopOrig) : null
											  }
										  </>}
									  </td>
									  <td>
										  <Price
											currency={child.currency}
											value={child.price}
											currencyClass={styles.currency}/>
										  {SHVO.showEuroPrices && <>
											  <br/>
											  <Price
												currency={'EUR'}
												value={ConvertToEUR(child.price)}
												currencyClass={styles.currency}/>
										  </>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>

						  {
							  (child.percentOff > 0) ?
								<div data-layout="col 12">
									<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
										<div
										  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left margin-right--20"
										  className={helpers.orderServiceDiscount}>
											{__t('-:percentOff% отстъпка', {percentOff: child.percentOff})}
										</div>
									</div>
								</div>
								: ''
						  }
					  </div>
					)
				})

				: undefined
		  }

		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги край*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

	  </section>
	);

};

CartLineVPS.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceType: PropTypes.string.isRequired,
		serviceTypeName: PropTypes.string.isRequired,
		servicePriceId: PropTypes.string.isRequired,
		cPanelName: PropTypes.string,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		canDelete: PropTypes.bool,
		mainDomainData: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
			domainTLD: PropTypes.string,
			isCyrillic: PropTypes.bool,
			lineId: PropTypes.string,
			name: PropTypes.string,
		})]),
		priceData: PropTypes.arrayOf(
		  PropTypes.shape({
			  currency: PropTypes.string,
			  oldPrice: PropTypes.string,
			  price: PropTypes.string,
			  priceId: PropTypes.string,
			  term: PropTypes.string,
		  })
		),
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
	}),
	childServices: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
		quantity: PropTypes.string,
		serviceType: PropTypes.string,
		currency: PropTypes.string,
		price: PropTypes.string,
	})]),
	taxonomy: PropTypes.object,
	removeService: PropTypes.func.isRequired,
	changeServiceTerm: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool
};

export default CartLineVPS;